import {actionTypes, flightBoardingDataTypes, flightRegistrationDataTypes, resourceTypes} from "../types";
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';
import { serialize } from "@/functions.js";

const TaskFlightData = {
    error: '',
    info: {},
    init: function () {
        return m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/data'
        }).then(function (response) {
            server.setOnline();

            TaskFlightData.info = response.info;

            storage.config = response.config;

            server.initPing();
            appNotification.init();

            loader.hide();

            return response;
        }, function (response) {
            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },

    savePassengersInfo: function (e) {
        e.preventDefault();
        TaskFlightData.error = '';

        loader.show();

        const data = serialize(e.target);

        m.request({
            method: 'PUT',
            url: '/api/flight/' + TaskFlightData.info.flightId + '/info/passengers',
            data: data
        }).then(function () {
            server.setOnline();
            loader.hide();
            m.route('/task/' + m.route.param('taskId') + '/data');
        }, function (response) {

            data.type = actionTypes.passengersInfoSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    saveRegistrationBeginTime: function (e) {
        e.preventDefault();
        TaskFlightData.error = '';

        loader.show();

        var data = serialize(e.target);
        data.dataType = flightRegistrationDataTypes.beginTime;

        m.request({
            method: 'PUT',
            url: '/api/flight/' + TaskFlightData.info.flightId + '/info/registration',
            data: data
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            if (response.data) {
                TaskFlightData.info.CheckInBeginFactTime = data.CheckInBeginHours + ':' + data.CheckInBeginMinutes;
            } else {
                TaskFlightData.error = (m(".alert.alert-danger", 'Ошибка при выполении операции'));
            }
        }, function (response) {

            data.type = actionTypes.registrationBeginTimeSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    saveRegistrationEndTime: function (e) {
        e.preventDefault();
        TaskFlightData.error = '';

        loader.show();

        var data = serialize(e.target);
        data.dataType = flightRegistrationDataTypes.endTime;

        m.request({
            method: 'PUT',
            url: '/api/flight/' + TaskFlightData.info.flightId + '/info/registration',
            data: data
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            if (response.data) {
                TaskFlightData.info.CheckInEndFactTime = data.CheckInEndHours + ':' + data.CheckInEndMinutes;
            } else {
                TaskFlightData.error = (m(".alert.alert-danger", 'Ошибка при выполении операции'));
            }
        }, function (response) {

            data.type = actionTypes.registrationEndTimeSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    saveRegistrationLastPaxQueueTime: function (e) {
        e.preventDefault();
        TaskFlightData.error = '';

        loader.show();

        var data = serialize(e.target);
        data.dataType = flightRegistrationDataTypes.lastPaxQueueTime;

        m.request({
            method: 'PUT',
            url: '/api/flight/' + TaskFlightData.info.flightId + '/info/registration',
            data: data
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            if (!response.data) {
                TaskFlightData.error = (m(".alert.alert-danger", 'Ошибка при выполении операции'));
            } else {
                TaskFlightData.info.LastPaxQueueTime = data.LastPaxQueueTime;
            }
        }, function (response) {

            data.type = actionTypes.registrationLastPaxQueueTimeSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    saveRegistrationAvgPaxQueueTime: function (e) {
        e.preventDefault();
        TaskFlightData.error = '';

        loader.show();

        var data = serialize(e.target);
        data.dataType = flightRegistrationDataTypes.avgPaxQueueTime;

        m.request({
            method: 'PUT',
            url: '/api/flight/' + TaskFlightData.info.flightId + '/info/registration',
            data: data
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            if (!response.data) {
                TaskFlightData.error = (m(".alert.alert-danger", 'Ошибка при выполении операции'));
            } else {
                TaskFlightData.info.AvgPaxQueueTime = data.AvgPaxQueueTime;
            }
        }, function (response) {

            data.type = actionTypes.registrationAvgPaxQueueTimeSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    saveRegistrationPaxRegPercent: function (e) {
        e.preventDefault();
        TaskFlightData.error = '';

        loader.show();

        var data = serialize(e.target);
        data.dataType = flightRegistrationDataTypes.paxRegPercent;

        m.request({
            method: 'PUT',
            url: '/api/flight/' + TaskFlightData.info.flightId + '/info/registration',
            data: data
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            if (!response.data) {
                TaskFlightData.error = (m(".alert.alert-danger", 'Ошибка при выполении операции'));
            } else {
                TaskFlightData.info.PaxRegPercent = data.PaxRegPercent;
            }
        }, function (response) {

            data.type = actionTypes.registrationPaxRegPercentSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    saveBoardingBeginTime: function (e) {

        e.preventDefault();
        TaskFlightData.error = '';

        loader.show();

        var data = serialize(e.target);
        data.dataType = flightBoardingDataTypes.beginTime;

        m.request({
            method: 'PUT',
            url: '/api/flight/' + TaskFlightData.info.flightId + '/info/boarding',
            data: data
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            if (response.data) {
                TaskFlightData.info.BoardingBeginFactTime = data.BoardingBeginHours + ':' + data.BoardingBeginMinutes;
            } else {
                TaskFlightData.error = (m(".alert.alert-danger", 'Ошибка при выполении операции'));
            }
        }, function (response) {

            data.type = actionTypes.boardingBeginTimeSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    saveBoardingEndTime: function (e) {
        e.preventDefault();
        TaskFlightData.error = '';

        loader.show();

        var data = serialize(e.target);
        data.dataType = flightBoardingDataTypes.endTime;

        m.request({
            method: 'PUT',
            url: '/api/flight/' + TaskFlightData.info.flightId + '/info/boarding',
            data: data
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            if (response.data) {
                TaskFlightData.info.BoardingEndFactTime = data.BoardingEndHours + ':' + data.BoardingEndMinutes;
            } else {
                TaskFlightData.error = (m(".alert.alert-danger", 'Ошибка при выполении операции'));
            }
        }, function (response) {

            data.type = actionTypes.boardingEndTimeSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    saveBoardingScanBeginTime: function (e) {
        e.preventDefault();
        TaskFlightData.error = '';

        loader.show();

        var data = serialize(e.target);
        data.dataType = flightBoardingDataTypes.scanBeginTime;

        m.request({
            method: 'PUT',
            url: '/api/flight/' + TaskFlightData.info.flightId + '/info/boarding',
            data: data
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            if (response.data) {
                TaskFlightData.info.ScanBeginTime = data.ScanBeginHours + ':' + data.ScanBeginMinutes;
            } else {
                TaskFlightData.error = (m(".alert.alert-danger", 'Ошибка при выполении операции'));
            }
        }, function (response) {

            data.type = actionTypes.boardingScanBeginTimeSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    saveBoardingScanEndTime: function (e) {
        e.preventDefault();
        TaskFlightData.error = '';

        loader.show();

        var data = serialize(e.target);
        data.dataType = flightBoardingDataTypes.scanEndTime;

        m.request({
            method: 'PUT',
            url: '/api/flight/' + TaskFlightData.info.flightId + '/info/boarding',
            data: data
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            if (response.data) {
                TaskFlightData.info.ScanEndTime = data.ScanEndHours + ':' + data.ScanEndMinutes;
            } else {
                TaskFlightData.error = (m(".alert.alert-danger", 'Ошибка при выполении операции'));
            }
        }, function (response) {

            data.type = actionTypes.boardingScanEndTimeSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    saveBoardingBuses: function (e) {
        e.preventDefault();
        TaskFlightData.error = '';

        loader.show();

        var data = serialize(e.target);
        data.dataType = flightBoardingDataTypes.buses;

        m.request({
            method: 'PUT',
            url: '/api/flight/' + TaskFlightData.info.flightId + '/info/boarding',
            data: data
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            if (!response.data) {
                TaskFlightData.error = (m(".alert.alert-danger", 'Ошибка при выполении операции'));
            } else {
                TaskFlightData.info.Buses = data.Buses;
            }
        }, function (response) {

            data.type = actionTypes.boardingBusesSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                TaskFlightData.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    }
};

export const TaskFlightDataPage = {
    controller: function () {
        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        const data = TaskFlightData.init();

        return {
            data: data,
            topMenu: [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ]
        }
    },
    view: function (ctrl) {
        const ticketsE = TaskFlightData.info.AdultEconomy||0 + TaskFlightData.info.ChildrenEconomy||0 + TaskFlightData.info.InfantEconomy||0
        const ticketsB = TaskFlightData.info.AdultBusiness||0 + TaskFlightData.info.ChildrenBusiness||0 + TaskFlightData.info.InfantBusiness||0
        const ticketsF = TaskFlightData.info.AdultFirst||0 + TaskFlightData.info.ChildrenFirst||0 + TaskFlightData.info.InfantFirst||0
        return [
            m.component(HeaderMenuBlock, {
                time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", ''),
            m.component(flightMenuBlock, {
                board: ctrl.data().board,
                menu: ctrl.data().menu,
                tasks: ctrl.data().tasks,
                currentTask: ctrl.data().currentTask,
                tab: 'data'
            }),
            TaskFlightData.error,
            m(".container[style='padding-top:10px']", [
                m("form.form-horizontal", {
                    onsubmit: TaskFlightData.savePassengersInfo.bind(this)
                }, [
                    m(".row", [
                        m(".col-xs-12[style='padding:5px 15px']", "Пассажиры")
                    ]),
                    m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                        m(".col-xs-3", ""),
                        m("label.control-label.col-xs-3", "Y"),
                        m("label.control-label.col-xs-3", "C"),
                        m("label.control-label.col-xs-3", "F")
                    ]),
                    m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                        m("label.control-label.col-xs-3", "Всего"),
                        m(".col-xs-3", [
                            m("input.form-control[type='text']", {
                                disabled: true,
                                value: ticketsE
                            })
                        ]),
                        m(".col-xs-3", [
                            m("input.form-control[type='text']", {
                                disabled: true,
                                value: ticketsB
                            })
                        ]),
                        m(".col-xs-3", [
                            m("input.form-control[type='text']", {
                                disabled: true,
                                value: ticketsF
                            })
                        ])
                    ]),
                    m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                        m("label.control-label.col-xs-3", "Взрослые"),
                        m(".col-xs-3", [
                            m("input.form-control[type='text'][name='AdultEconomy']", {
                                disabled: true,
                                value: TaskFlightData.info.AdultEconomy
                            })
                        ]),
                        m(".col-xs-3", [
                            m("input.form-control[type='text'][name='AdultBusiness']", {
                                disabled: true,
                                value: TaskFlightData.info.AdultBusiness
                            })
                        ]),
                        m(".col-xs-3", [
                            m("input.form-control[type='text'][name='AdultFirst']", {
                                disabled: true,
                                value: TaskFlightData.info.AdultFirst
                            })
                        ])
                    ]),
                    m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                        m("label.control-label.col-xs-3", "РБ"),
                        m(".col-xs-3", [
                            m("input.form-control[type='text'][name='ChildrenEconomy']", {
                                disabled: true,
                                value: TaskFlightData.info.ChildrenEconomy
                            })
                        ]),
                        m(".col-xs-3", [
                            m("input.form-control[type='text'][name='ChildrenBusiness']", {
                                disabled: true,
                                value: TaskFlightData.info.ChildrenBusiness
                            })
                        ]),
                        m(".col-xs-3", [
                            m("input.form-control[type='text'][name='ChildrenFirst']", {
                                disabled: true,
                                value: TaskFlightData.info.ChildrenFirst
                            })
                        ])
                    ]),
                    m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                        m("label.control-label.col-xs-3", "РМ"),
                        m(".col-xs-3", [
                            m("input.form-control[type='text'][name='InfantEconomy']", {
                                disabled: true,
                                value: TaskFlightData.info.InfantEconomy
                            })
                        ]),
                        m(".col-xs-3", [
                            m("input.form-control[type='text'][name='InfantBusiness']", {
                                disabled: true,
                                value: TaskFlightData.info.InfantBusiness
                            })
                        ]),
                        m(".col-xs-3", [
                            m("input.form-control[type='text'][name='InfantFirst']", {
                                disabled: true,
                                value: TaskFlightData.info.InfantFirst
                            })
                        ])
                    ]),
                    // m(".row[style='margin:15px -15px']", [
                    //     m(".col-xs-12", [
                    //         m("button.btn.btn-info.btn-block.btn-lg[type='submit']", "Сохранить")
                    //     ])
                    // ])
                ]),
                TaskFlightData.info.alerts.length ? [
                    m(".row", [
                        m(".col-xs-12[style='padding:5px 15px']", "Предупреждения")
                    ]),
                    m(".row.bg-warning[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                        m(".col-xs-12", TaskFlightData.info.alerts.join(', '))
                    ])] : ''
            ])
        ]
    }
};
